import React, { Component } from 'react';
import './Tela2.css';
import '../CampoDeRuido/A1/A1';
import $, { when } from "jquery";

class Tela2 extends Component{

    
    render(){
        return(    
        <div id="aquiemcima" className=" grandeCampoPreto2">
            {this.props.children}
        </div>
        )
    }
    

}

export default Tela2;